(() => {
    "use strict";

    /**
     * Pausa iframe YouTube só quando já carregou cross-origin (evita postMessage
     * com target origin errado enquanto o embed ainda está em about:blank).
     */
    window.sitePauseYoutubeIframe = function sitePauseYoutubeIframe(iframe) {
        if (!iframe?.contentWindow) {
            return;
        }

        const src = iframe.getAttribute("src") || "";
        if (!/youtube(-nocookie)?\.com/.test(src)) {
            return;
        }

        if (iframe.contentDocument !== null) {
            return;
        }

        try {
            const origin = src.startsWith("http")
                ? new URL(src, window.location.origin).origin
                : "https://www.youtube-nocookie.com";
            iframe.contentWindow.postMessage(
                JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
                origin
            );
        } catch (error) {
            /* iframe ainda não pronto */
        }
    };
})();
